import React, {useContext, useEffect} from 'react';
import {Button, Grid, useTheme} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useFormContext} from "react-hook-form";
import {FormAutocomplete} from '../../../common/form-fields';
import {SelectElementModelBE, SelectElementModelFE} from '../../../api/types/generic';
import {ExcessPlanResponse, FormProductPlan} from '../../../api/types/productPlan';
import {useCommercialCategoryRepository} from '../../../api/repositories/CommercialCategoryRepository';
import {useRecoilState} from "recoil";
import {commercialSegmentListAtom} from '../../../state/commercialSegmentsAtom';
import {useCommercialSegmentRepository} from '../../../api/repositories/CommercialSegmentRepository';
import {fromGenericBeToGenericFe} from '../../../utils';
import {CommercialCategorySelectFE} from '../../../api/types/commercialCategory';
import {commercialCategoryListAtom} from '../../../state/commercialCategoriesRecoil';
import {productCodesAtom} from '../../../state/locationGroupProductCodesRecoil';
import {useProductCodeRepository} from '../../../api/repositories/ProductCodeRepository';
import {ProductCodeSelectFE} from '../../../api/types/productCode';
import {useProductCodeLocationGroupRepository} from '../../../api/repositories/ProductCodeLocationGroupRepository';
import {locationGroupAtom} from '../../../state/locationGroupsRecoil';
import {useProductPlanRepository} from '../../../api/repositories/ProductPlanRepository';
import {exceptionPlanAtom, excessPlanAtom, newCombinationAtom, ratePlanAtom} from '../../../state/productPlan';
import {RateEntityResponse} from '../../../api/types/rate';
import {ExceptionListEntityResponse} from "../../../api/types/exceptionList";
import {useSearchParams} from "react-router-dom";
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";

const ProductPlanHeader = () => {

    // Use Theme
    const theme = useTheme();

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // Use Form Context
    const {register, resetField} = useFormContext<FormProductPlan>();

    // Use Context
    const {dispatchGlobalData, globalData: {user}} = useContext(GlobalContext);

    const form = useFormContext<FormProductPlan>();
    const watchAllForm = form.watch();

    console.log(watchAllForm)

    // Use Repository Hooks
    const {getCommercialCategories, getCommercialCategoriesByCommercialSegmentId} = useCommercialCategoryRepository();
    const {getCommercialSegments} = useCommercialSegmentRepository();
    const {getProductCodesByCommercialCategoryId, getProductCode} = useProductCodeRepository();
    const {getLocationGroupsByProductCode} = useProductCodeLocationGroupRepository();
    const {
        getRateCommercialCategoryLocationGroup,
        getExceptionPlanByProductCodeAndLocation,
        getExcessGroupByProductCodeAndLocation
    } = useProductPlanRepository();

    //Use Recoil
    const [commercialSegmentList, setCommercialSegmentList] = useRecoilState(commercialSegmentListAtom);
    const [commercialCategoryList, setCommercialCategoryList] = useRecoilState(commercialCategoryListAtom);
    const [productCodeList, setProductCodeList] = useRecoilState(productCodesAtom)
    const [locationGroupList, setLocationGroupList] = useRecoilState(locationGroupAtom);
    const [, setRatePlan] = useRecoilState(ratePlanAtom)
    const [, setExceptionPlan] = useRecoilState(exceptionPlanAtom)
    const [, setExcessPlan] = useRecoilState(excessPlanAtom)
    const [, setNewCombination] = useRecoilState(newCombinationAtom);

    // Use Search Params
    const [searchParams] = useSearchParams();

    //setto tutte le legalEntities options e le passo al filtro di ricerca ["all", "drivalia_it","drivalia_fr"]
    const legalEntityOptions: SelectElementModelFE[] = user.legalEntities?.map(
        (el: SelectElementModelBE) => ({
            code: el.name,
            label: t('translation:legalEntities.'.concat(el.name))
        })
    );

    //se utente clicca su all, mando  ["drivalia_it","drivalia_fr"]
    const optionsFiltered = legalEntityOptions
        .filter(function (el) {
            return el.code !== "all";
        });

    const everyLegalEntitiesWithoutAll = legalEntityOptions
        .map((el) => el.code as string)
        .filter((el) => el !== "all");

    //setto tutti i dealers options
    const dealerOption: SelectElementModelFE[] = user.dealers?.map(
        (el: SelectElementModelBE) => ({
            code: el.name,
            label: t('translation:dealers.'.concat(el.name))
        })
    );

    const dealerFilteredOptions = dealerOption
        .map((el) => el.code as string)
        .filter((el) => el !== "all");

    const getStaticContents = async () => {
        try {
            // Commercial Segment
            const commercialSegmentsData = await getCommercialSegments();
            const commercialSegmentList: SelectElementModelFE[] = fromGenericBeToGenericFe(commercialSegmentsData);
            setCommercialSegmentList(commercialSegmentList);

            // Commercial category
            const commercialCategoriesData = await getCommercialCategories();
            const commercialCategoryList: CommercialCategorySelectFE[] = fromGenericBeToGenericFe(commercialCategoriesData);
            setCommercialCategoryList(commercialCategoryList);

            // PrePopolamento productCode che arriva da SM
            const param: any = {};

            searchParams.forEach((value, key) => {
                param[key] = value;
            });

            if (param?.productCode) {
                getProductCode(param?.productCode).then(async (res) => {
                    if (res) {
                        form.setValue("productPlan.productCode", {
                            code: res.id,
                            label: res.id + " - " + res.name
                        })
                        form.setValue("productPlan.commercialSegment", {
                            code: res.commercialCategory.commercialSegment.id,
                            label: res.commercialCategory.commercialSegment.name
                        })
                        form.setValue("productPlan.commercialCategory", {
                            code: res.commercialCategory.id,
                            label: res.commercialCategory.name
                        })
                        const productCodesData = await getProductCodesByCommercialCategoryId(res.commercialCategory.id as string, dealerFilteredOptions, everyLegalEntitiesWithoutAll);
                        const productCodeList: ProductCodeSelectFE[] = productCodesData.map(product => ({
                            code: product.id,
                            label: product.id + " - " + product.name,
                            commercialCategory: product.commercialCategory,
                            active: product.active
                        }));
                        setProductCodeList(productCodeList);

                        const locationGroupsData = await getLocationGroupsByProductCode(res.id as string);
                        const locationGroupList: SelectElementModelFE[] = fromGenericBeToGenericFe(locationGroupsData);
                        setLocationGroupList(locationGroupList);
                        handleChangeLocationGroup(locationGroupList[0])
                    }
                })
            } else return null;
        } catch (e) {
        }
    }

    //Use Effect
    useEffect(() => {
        getStaticContents();
    }, [])

    //Onchange Commercial Segment
    const handleChangeCommercialSegment = async (value: any) => {
        if (value) {
            form.setValue("productPlan.commercialSegment", value)
            resetField("productPlan.commercialCategory")
            resetField("productPlan.productCode")
            resetField("productPlan.locationGroup")
            // Commercial Category by Segment ID
            const commercialCategoriesData = await getCommercialCategoriesByCommercialSegmentId((value as SelectElementModelFE).code as string);
            const commercialCategoryList: CommercialCategorySelectFE[] = fromGenericBeToGenericFe(commercialCategoriesData);
            form.setValue("productPlan.commercialCategory", null);
            setCommercialCategoryList(commercialCategoryList);
            setNewCombination(null)
        } else {
            //Reset header fields
            form.setValue("productPlan.commercialSegment", value);
            form.setValue("productPlan.commercialCategory", value);
            form.setValue("productPlan.productCode", value);
            form.setValue("productPlan.locationGroup", value);
            //Reset all fields
            resetFields();
            // All Commercial category
            const commercialCategoriesData = await getCommercialCategories();
            const commercialCategoryList: CommercialCategorySelectFE[] = fromGenericBeToGenericFe(commercialCategoriesData);
            setCommercialCategoryList(commercialCategoryList);
        }
    }

    //Onchange Commercial Category
    const handleChangeCommercialCategory = async (value: any) => {
        if (value) {
            form.setValue("productPlan.commercialCategory", value)
            resetField("productPlan.productCode")
            resetField("productPlan.locationGroup")
            const productCodesData = await getProductCodesByCommercialCategoryId((value as CommercialCategorySelectFE).code as string, dealerFilteredOptions, everyLegalEntitiesWithoutAll);
            const productCodeList: ProductCodeSelectFE[] = productCodesData.map(product => ({
                code: product.id,
                label: product.id + " - " + product.name,
                commercialCategory: product.commercialCategory,
                active: product.active,
                dealer: product.dealer,
                legalEntity: product.legalEntity
            }));
            form.setValue("productPlan.productCode", null);
            setProductCodeList(productCodeList);
            setNewCombination(null)
        } else {
            //Reset header fields
            form.setValue("productPlan.commercialCategory", value);
            form.setValue("productPlan.productCode", value);
            form.setValue("productPlan.locationGroup", value);
            //Reset all fields
            resetFields();
            setProductCodeList([]);
        }
    }

    //Onchange product code
    const handleChangeProductCode = async (value: SelectElementModelFE) => {
        if (value) {
            console.log(value)
            form.setValue("productPlan.productCode", value)
            resetField("productPlan.locationGroup")
            const locationGroupsData = await getLocationGroupsByProductCode((value as CommercialCategorySelectFE).code as string);
            const locationGroupList: SelectElementModelFE[] = fromGenericBeToGenericFe(locationGroupsData);
            setLocationGroupList(locationGroupList);
            //Set default first location
            handleChangeLocationGroup(locationGroupList[0])
            setNewCombination(null)
        } else {
            //Reset Header fields
            form.setValue("productPlan.productCode", value);
            form.setValue("productPlan.locationGroup", value);
            //Reset all fields
            resetFields();
            setLocationGroupList([]);
        }
    }

    //Onchange Location group
    const handleChangeLocationGroup = async (value: SelectElementModelFE) => {
        if (value) {
            form.setValue("productPlan.locationGroup", value)
            //Setto tariffa base partendo da location group e product code
            const ratePlanResponse: RateEntityResponse[] = await getRateCommercialCategoryLocationGroup(form.getValues("productPlan.locationGroup.code") as number, form.getValues("productPlan.productCode.code") as string, (watchAllForm.productPlan.productCode as ProductCodeSelectFE).dealer as string)
            setRatePlan(ratePlanResponse)
            //Setto exception plan partendo da location group e product code
            const exceptionPlanResponse: ExceptionListEntityResponse = await getExceptionPlanByProductCodeAndLocation(form.getValues("productPlan.locationGroup.code") as number, form.getValues("productPlan.productCode.code") as string, (watchAllForm.productPlan.productCode as ProductCodeSelectFE).dealer as string)
            setExceptionPlan(exceptionPlanResponse)
            const excessPlanResponse: ExcessPlanResponse = await getExcessGroupByProductCodeAndLocation(form.getValues("productPlan.locationGroup.code") as number, form.getValues("productPlan.productCode.code") as string, (watchAllForm.productPlan.productCode as ProductCodeSelectFE).dealer as string, (watchAllForm.productPlan.productCode as ProductCodeSelectFE).legalEntity as string)
            setExcessPlan(excessPlanResponse.excessGroup === null ? null : excessPlanResponse)
            setNewCombination(null)
        } else {
            //Reset header fields
            form.setValue("productPlan.locationGroup", value);
            //Reset all fields
            resetFields();
        }
    }

    //Reset field
    const resetFields = () => {
        setRatePlan([])
        setExceptionPlan(null)
        setExcessPlan(null)
        setNewCombination(null)
        resetField("productPlan.ratePlan.rate")
        resetField("productPlan.ratePlan.carGroup")
        resetField("productPlan.ratePlan.rentalPeriod")
        resetField("productPlan.ratePlan.price")
        resetField("productPlan.ratePlan.extraKm")
        resetField("productPlan.exceptionPlan.newCombination.name")
        resetField("productPlan.exceptionPlan.newCombination.from")
        resetField("productPlan.exceptionPlan.newCombination.to")
        resetField("productPlan.exceptionPlan.viewCombination.name")
        resetField("productPlan.exceptionPlan.viewCombination.from")
        resetField("productPlan.exceptionPlan.viewCombination.to")
        resetField("productPlan.exceptionPlan.viewCombination.exception")
        resetField("productPlan.exceptionPlan.newException.ancillary")
        resetField("productPlan.exceptionPlan.newException.exceptionName")
        resetField("productPlan.excessPlan.name")
        resetField("productPlan.excessPlan.from")
        resetField("productPlan.excessPlan.to")
        resetField("productPlan.excessPlan.carGroup")
    }

    const handleButtonReset = () => {
        //Reset header fields
        form.setValue("productPlan.commercialSegment", null);
        form.setValue("productPlan.commercialCategory", null);
        form.setValue("productPlan.productCode", null);
        form.setValue("productPlan.locationGroup", null);
        //Reset all fields
        resetFields();
    }

    return (
        <Grid container item xs={12} md={12} lg={12} spacing={2} rowSpacing={3}>
            {/* COMMERCIAL SEGMENTS */}
            <Grid item xs={12} md={3}>
                <FormAutocomplete
                    {...register("productPlan.commercialSegment")}
                    label={`${t("pricing:rate.form.labels.mainDefinitionLabels.commercialSegment")}*`}
                    options={commercialSegmentList || []}
                    isOptionEqualToValue={(
                        option: SelectElementModelFE,
                        value: SelectElementModelFE
                    ) => option?.code === value?.code}
                    handleChange={handleChangeCommercialSegment as Function}
                />
            </Grid>
            {/* COMMERCIAL CATEGORY */}
            <Grid item xs={12} md={3}>
                <FormAutocomplete
                    {...register("productPlan.commercialCategory")}
                    label={`${t("pricing:rate.form.labels.mainDefinitionLabels.commercialCategory")}*`}
                    options={commercialCategoryList || []}
                    isOptionEqualToValue={(
                        option: SelectElementModelFE,
                        value: SelectElementModelFE
                    ) => option?.code === value?.code}
                    readOnly={!watchAllForm.productPlan.commercialSegment}
                    handleChange={handleChangeCommercialCategory as Function}
                />
            </Grid>
            {/* PRODUCT CODE */}
            <Grid item xs={12} md={3}>
                <FormAutocomplete
                    {...register("productPlan.productCode")}
                    label={`${t("pricing:rateProductCodeLocationGroup.form.labels.productCode")}*`}
                    options={productCodeList || []}
                    isOptionEqualToValue={(
                        option: SelectElementModelFE,
                        value: SelectElementModelFE
                    ) => option?.code === value?.code}
                    readOnly={!watchAllForm.productPlan.commercialCategory}
                    handleChange={handleChangeProductCode as Function}
                />
            </Grid>
            {/* LOCATION GROUP */}
            <Grid item xs={12} md={3}>
                <FormAutocomplete
                    {...register("productPlan.locationGroup")}
                    label={`${t("pricing:alert.labels.groupsOfLocations")}*`}
                    options={locationGroupList || []}
                    readOnly={!watchAllForm.productPlan.productCode}
                    isOptionEqualToValue={(
                        option: SelectElementModelFE,
                        value: SelectElementModelFE
                    ) => option?.code === value?.code}
                    handleChange={handleChangeLocationGroup as Function}
                />
            </Grid>
            <Grid item xs={12} md={12}
                  sx={{display: "flex", justifyContent: "flex-end", alignItems: "center",}}>
                <Button
                    color={"accent"}
                    type={"button"}
                    onClick={handleButtonReset}
                    sx={{border: `1px solid ${theme.palette.accent.main}`}}
                >
                    Reset
                </Button>
            </Grid>
        </Grid>
    );
}

export default ProductPlanHeader;